import { render } from "./InventoryTemplateDialog.vue?vue&type=template&id=c4f52ba4"
import script from "./InventoryTemplateDialog.vue?vue&type=script&lang=js"
export * from "./InventoryTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__